import Content, { ContentNS } from "content/content";
import { getSessionRelativeUrl } from "features/shared/hooks/navigation/useFlowRedirect";
import useNavigateWithQuery from "features/shared/hooks/navigation/useNavigateWithQuery";
import useMultiPaxSession from "features/shared/hooks/useMultiPaxSession";
import ChecklistResolutionStatus from "models/checklist/checklist-resolution-status";
import { FC } from "react";
import NativeBridge from "services/native-bridge/native-bridge";
import { useAppStore } from "store/store";

import SuccessBannerClient from "./SuccessBannerClient";

type BannerProps = object

const SuccessBanner: FC<BannerProps> = () => {
  useAppStore((state) => state.locale);
  const navigate = useNavigateWithQuery();

  const textUI = (s: string) => Content.shared.t(s, { ns: ContentNS.ui });
  const paxSessions = useAppStore((state) => state.paxSessions);
  const sessionId = useAppStore((state) => state.sessionId);
  const isMultiPax = useMultiPaxSession();
  const returnUrl = useAppStore((state) => state.returnUrl);
  const isEmbedded = NativeBridge.shared.isEmbedded;

  const allResolved = paxSessions.every(
    (paxSession) =>
      paxSession.checklist.resolutionStatus ===
      ChecklistResolutionStatus.ReadyToFly
  );

  let title: string = "";
  let description: string = "";
  let buttonText: string = "";
  let onClick: () => void = () => {};

  if (!isMultiPax) {
    title = textUI("success-banner.single-pax.title");
    description = textUI("success-banner.single-pax.description");
    buttonText = textUI("success-banner.single-pax.button-text");
    onClick = () => {
      if (isEmbedded) {
        NativeBridge.shared.closeFlow("ready_to_fly");
        return;
      }
      if (returnUrl !== null) {
        const url = new URL(returnUrl);
        url.searchParams.set("ready_to_fly", "true");
        window.location.assign(url.toString());
      }
    };
  } else if (!allResolved) {
    title = textUI("success-banner.multipax.this-pax-ready.title");
    description = textUI("success-banner.multipax.this-pax-ready.description");
    buttonText = textUI("success-banner.multipax.this-pax-ready.button-text");
    onClick = () => {
      navigate(`${getSessionRelativeUrl(sessionId)}/select-passenger`);
    };
  } else {
    title = textUI("success-banner.multipax.all-ready.title");
    description = textUI("success-banner.multipax.all-ready.description");
    buttonText = textUI("success-banner.multipax.all-ready.button-text");
    onClick = () => {
      if (isEmbedded) {
        NativeBridge.shared.closeFlow("ready_to_fly");
        return;
      }
      if (returnUrl !== null) {
        const url = new URL(returnUrl);
        url.searchParams.set("ready_to_fly", "true");
        window.location.assign(url.toString());
      }
    };
  }

  return (
    <SuccessBannerClient
      title={title}
      description={description}
      buttonText={buttonText}
      isButtonVisible={
        buttonText.trim() !== "" && (isEmbedded || returnUrl !== null)
      }
      onClick={onClick}
    />
  );
};

export default SuccessBanner;
